// extracted by mini-css-extract-plugin
export default {"root":"Badge_root__kNYGO","icon":"Badge_icon__n+lII","content":"Badge_content__2t874","active":"Badge_active__EtUz8"};